var _path, _path2, _path3, _path4, _circle, _circle2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBaker(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    viewBox: "0 0 470 470",
    xmlSpace: "preserve",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCECFF"
    },
    d: "M375,307.5L345,385l30,77.5h40v-115C415,325.409,397.092,307.5,375,307.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M325,307.5l-30-30H175c-16.5,0-30,13.5-30,30H95c-22.092,0-40,17.909-40,40v115h240l15-43.27   l15,43.27h50v-155H325z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EDF8FF"
    },
    d: "M295,277.5v185h30v-155C325,291,311.5,277.5,295,277.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC8BB"
    },
    d: "M134.9,172.5c-16.569,0-30,13.432-30,30c0,16.569,13.431,30,30,30H235v-60H134.9z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE9F88"
    },
    d: "M335.1,172.5H235v60h100.1c16.569,0,30-13.431,30-30C365.1,185.932,351.669,172.5,335.1,172.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE9F88"
    },
    d: "M235,97.5v210c49.706,0,90-40.294,90-90v-30C325,137.794,284.706,97.5,235,97.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FEC8BB"
    },
    d: "M295,217.5v-30c0-49.706-26.863-90-60-90c-49.706,0-90,40.294-90,90v30c0,49.706,40.294,90,90,90   C268.137,307.5,295,267.206,295,217.5z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FE9F88"
    },
    cx: 180,
    cy: 217.5,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FD7555"
    },
    d: "M295,203.372l-10.379,14.12l9.613,14.392C300.455,230.055,305,224.313,305,217.5   C305,210.972,300.822,205.433,295,203.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE9F88"
    },
    d: "M295,203.372c-1.566-0.555-3.244-0.872-5-0.872c-8.284,0-15,6.716-15,15c0,8.284,6.716,15,15,15   c1.472,0,2.89-0.221,4.234-0.616C294.736,227.2,295,222.396,295,217.5V203.372z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#EF431D",
      strokeWidth: 15,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: "   M218.5,232.5c2.412,6.785,8.887,11.645,16.5,11.645s14.088-4.86,16.5-11.645"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#99D9FF"
    },
    points: "145,82.5 150.129,157.5 319.872,157.5 325,82.5  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#CCECFF"
    },
    d: "M310,27.5v100c27.614,0,50-22.386,50-50C360,49.886,337.614,27.5,310,27.5z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M330,77.5c0-27.614-8.954-50-20-50c-9.136,0-17.692,2.462-25.062,6.742   C274.181,18.122,255.833,7.5,235,7.5s-39.181,10.622-49.938,26.742C177.692,29.962,169.136,27.5,160,27.5   c-27.614,0-50,22.386-50,50c0,27.614,22.386,50,50,50c13.899,0,26.47-5.675,35.532-14.83c10.551,9.227,24.351,14.83,39.468,14.83   s28.917-5.603,39.468-14.83c9.062,9.155,21.633,14.83,35.532,14.83C321.046,127.5,330,105.114,330,77.5z"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M375,300h-43.271c-2.183-10.502-8.856-19.618-18.067-24.964c7.575-10.328,13.168-22.194,16.213-35.036h5.225   c20.678,0,37.5-16.822,37.5-37.5S355.777,165,335.1,165h-5.237c-0.674-2.848-1.477-5.666-2.409-8.45l1.699-24.842   C351.469,123.8,367.5,102.492,367.5,77.5c0-31.706-25.794-57.5-57.5-57.5c-7.858,0-15.626,1.617-22.796,4.715   C274.437,9.129,255.37,0,235,0s-39.437,9.129-52.204,24.715C175.626,21.617,167.858,20,160,20c-31.706,0-57.5,25.794-57.5,57.5   c0,24.992,16.031,46.3,38.347,54.208l1.699,24.842c-0.932,2.784-1.734,5.603-2.409,8.45H134.9c-20.678,0-37.5,16.822-37.5,37.5   s16.822,37.5,37.5,37.5h5.225c3.045,12.843,8.639,24.709,16.214,35.037c-9.211,5.346-15.884,14.462-18.067,24.963H95   c-26.191,0-47.5,21.309-47.5,47.5v115c0,4.143,3.357,7.5,7.5,7.5h360c4.143,0,7.5-3.357,7.5-7.5v-115   C422.5,321.309,401.191,300,375,300z M266.313,119.211c-1.694-3.779-6.131-5.474-9.911-3.776C249.641,118.464,242.44,120,235,120   c-12.699,0-24.962-4.608-34.53-12.976c-2.983-2.607-7.479-2.447-10.268,0.369C182.155,115.523,171.429,120,160,120   c-23.435,0-42.5-19.065-42.5-42.5S136.565,35,160,35c7.479,0,14.844,1.98,21.297,5.728c3.426,1.989,7.806,0.973,10.004-2.323   C201.081,23.749,217.417,15,235,15s33.919,8.749,43.699,23.404c2.198,3.295,6.581,4.312,10.004,2.323   C295.156,36.98,302.521,35,310,35c23.435,0,42.5,19.065,42.5,42.5S333.435,120,310,120c-6.062,0-11.931-1.263-17.445-3.752   c-3.78-1.706-8.219-0.024-9.922,3.75c-1.704,3.775-0.025,8.218,3.75,9.922c7.468,3.371,15.413,5.08,23.617,5.08   c1.313,0,2.612-0.06,3.903-0.147L312.867,150H157.134l-1.036-15.147c1.291,0.087,2.59,0.147,3.903,0.147   c13.194,0,25.696-4.409,35.844-12.534C207.233,130.588,220.907,135,235,135c9.568,0,18.833-1.978,27.536-5.878   C266.315,127.429,268.007,122.991,266.313,119.211z M134.9,225c-12.406,0-22.5-10.094-22.5-22.5s10.094-22.5,22.5-22.5h2.898   c-0.19,2.488-0.299,4.988-0.299,7.5c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5c0-7.661,1.063-15.205,3.129-22.5h158.742   c2.066,7.294,3.129,14.837,3.129,22.5c0,4.143,3.357,7.5,7.5,7.5s7.5-3.357,7.5-7.5c0-2.512-0.109-5.012-0.299-7.5h2.898   c12.406,0,22.5,10.094,22.5,22.5S347.506,225,335.1,225h-2.885c0.189-2.476,0.286-4.977,0.286-7.5c0-4.143-3.357-7.5-7.5-7.5   s-7.5,3.357-7.5,7.5c0,45.49-37.01,82.5-82.5,82.5s-82.5-37.01-82.5-82.5c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5   c0,2.523,0.096,5.024,0.286,7.5H134.9z M62.5,347.5c0-17.921,14.579-32.5,32.5-32.5h50c4.143,0,7.5-3.357,7.5-7.5   c0-9.132,5.663-17.328,13.913-20.773C184.042,304.194,208.282,315,235,315c19.315,0,37.336-5.646,52.5-15.373V455h-165v-52.5   c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5V455h-45V347.5z M407.5,455h-55v-52.5c0-4.143-3.357-7.5-7.5-7.5s-7.5,3.357-7.5,7.5   V455h-35V287.788c0.365-0.351,0.727-0.705,1.087-1.062c8.249,3.445,13.913,11.64,13.913,20.773c0,4.143,3.357,7.5,7.5,7.5h50   c17.921,0,32.5,14.579,32.5,32.5V455z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M191.5,195h9.927c1.029,2.913,3.808,5,7.073,5c4.143,0,7.5-3.357,7.5-7.5v-5c0-4.143-3.357-7.5-7.5-7.5h-17   c-4.143,0-7.5,3.357-7.5,7.5S187.357,195,191.5,195z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M261.5,200c3.266,0,6.044-2.087,7.073-5h9.927c4.143,0,7.5-3.357,7.5-7.5s-3.357-7.5-7.5-7.5h-17   c-4.143,0-7.5,3.357-7.5,7.5v5C254,196.643,257.357,200,261.5,200z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M211.434,235.013c3.536,9.948,13.007,16.632,23.566,16.632s20.03-6.684,23.566-16.632c1.388-3.903-0.651-8.192-4.555-9.579   c-3.9-1.391-8.191,0.651-9.578,4.554c-1.416,3.982-5.207,6.657-9.434,6.657s-8.018-2.675-9.434-6.657   c-1.387-3.903-5.679-5.944-9.578-4.554C212.085,226.82,210.046,231.109,211.434,235.013z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 425,
    r: 7.5
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 257.5,
    cy: 365,
    r: 7.5
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaker);
export default __webpack_public_path__ + "static/media/baker.bb955533f3e7048f2b932c29e7f4613e.svg";
export { ForwardRef as ReactComponent };